module.exports = __webpack_public_path__ + "img/search_icon.e210a07.png";